import * as THREE from 'three';
import Action from '../../classes/Action';
import Engine from '../../classes/Engine';
import { ToolState } from '../../globals';
import DistanceTool from '../../classes/tools/DistanceTool';

export default class SetDistanceToolPoints extends Action
{
	constructor(tool: DistanceTool, newState: ToolState, previousState: ToolState, newActiveMode: boolean, previousActiveMode: boolean, startPoint?: THREE.Vector3, previousStartPoint?: THREE.Vector3, endPoint?: THREE.Vector3, previousEndPoint?: THREE.Vector3)
	{
		const actionName = "Placed Distance Tool";
		super([tool, newState, newActiveMode, startPoint, endPoint], [tool, previousState, previousActiveMode, previousStartPoint, previousEndPoint], actionName);
	}

	do(tool: DistanceTool, state: ToolState, activeMode: boolean, startPoint?: THREE.Vector3, endPoint?: THREE.Vector3)
	{
		tool.setStartingPoint(startPoint);
		tool.setEndPoint(endPoint);
		tool.state = state;
		tool.isActive = activeMode;
		if (state !== ToolState.Finalized)
		{
			Engine.getInstance().getToolsManager().setActiveTool(tool);
		}
	}
}
